module.exports = __webpack_public_path__ + "media/images/sp/stores/common/appeal_01@3x-bdf49c4252619a1e41db40111702d773.webp";